import { render, staticRenderFns } from "./caseSetting.vue?vue&type=template&id=5684442e&scoped=true&"
import script from "./caseSetting.vue?vue&type=script&lang=js&"
export * from "./caseSetting.vue?vue&type=script&lang=js&"
import style0 from "./caseSetting.vue?vue&type=style&index=0&id=5684442e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5684442e",
  null
  
)

export default component.exports